<template>
    <v-layout column>
        <v-layout :row="$vuetify.breakpoint.mdAndUp" :column="$vuetify.breakpoint.smAndDown" wrap>
            <!-- Add button for desktop view -->
            <v-flex v-if="$vuetify.breakpoint.mdAndUp">
                <v-layout pb-1>
                    <v-flex sm5 md4 >
                        <v-btn block color="primary" @click="addSpray()">Add</v-btn>
                    </v-flex>
                    <v-flex sm5 md4 pl-1>
                        <v-btn block color="primary" @click="showImportSpray()">Import</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!-- Sync Indicators -->
            <v-flex>
                <v-layout row wrap align-center :justify-center="$vuetify.breakpoint.smAndDown" :justify-end="$vuetify.breakpoint.mdAndUp" fill-height>
                        <unsynced-status-indicator name="Unsynced Add" :unsyncedCount="unsyncedSprayAddEntries"></unsynced-status-indicator>
                        <unsynced-status-indicator name="Unsynced Edit" :unsyncedCount="unsyncedSprayEditEntries"></unsynced-status-indicator>
                        <unsynced-status-indicator name="Unsynced Delete" :unsyncedCount="unsyncedSprayDeleteEntries"></unsynced-status-indicator>
                        <v-btn icon v-if="loading">
                           <v-layout align-center justify-center>
                                <v-progress-circular indeterminate></v-progress-circular>
                            </v-layout>
                        </v-btn>
                        <v-btn icon color="error" @click="syncUnsyncedData()" v-else-if="unsyncedSprayAddEntries + unsyncedSprayEditEntries + unsyncedSprayDeleteEntries > 0">
                            <v-icon>refresh</v-icon>
                        </v-btn>
                        <v-btn icon color="primary" v-else>
                            <v-icon>check</v-icon>
                        </v-btn>
                </v-layout>
            </v-flex>
            <!-- Add button for tablet view -->
             <v-flex v-if="$vuetify.breakpoint.smAndDown">
                <v-layout pb-1>
                    <v-flex xs12>
                        <v-btn block color="primary" @click="addSpray()">Add</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
         </v-layout>
        <!-- Plant, Division and Location Selects -->
       <v-layout row wrap pt-2>
            <v-flex xs12 sm4 px-1> 
                <v-autocomplete :items="plants" v-model="selectedPlant" box chips multiple
                    item-text="PlantName" item-value="PlantID" label="Plant" placeholder="Plant"
                ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4 px-1> 
                <v-autocomplete :items="divisions" v-model="selectedDivision" box chips multiple
                    item-text="DivisionName" item-value="DivisionID" label="Division" placeholder="Division"
                ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4 px-1> 
                  <v-autocomplete :items="locations" v-model="selectedLocation" box chips multiple
                    item-text="LocationName" item-value="LocationID" label="Location" placeholder="Location"
                ></v-autocomplete>
            </v-flex>
            <v-flex xs12>
                <v-layout  justify-center="true" row wrap align-center> 
                    <v-flex xs12 sm4 px-1 >
                        <v-btn block color="primary" :disabled="saving" @click="clearFilter">Clear Filter</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <!-- Spray Entries Table -->
        <v-layout row wrap>
            <v-flex xs12>
                 <v-data-table
                    :headers="headers" 
                    :items="spraies"
                    class="sparyManagementTable v-data-table--fixed-header"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination">
                    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                        <td>{{props.item.PlantName}}</td>
                        <td>{{props.item.DivisionName}}</td>
                        <td>{{props.item.LocationName}}</td>
                        <td>{{props.item.ProductChemical}}</td>
                        <td>{{props.item.SprayDateTime | formatDateTime}}</td>
                        <td>{{props.item.WithholdDateTime | formatDateTime}}</td>
                        <td>{{props.item.ValidDateTime | formatDateTime}}</td>
                        <td>{{props.item.AllowPick == true ? "Yes": "No" }}</td>
                        <td><v-btn color="primary" :disabled="props.item.SprayID < 0" block @click="editSpray(props.item)">Edit</v-btn></td>
                        <td><v-btn color="error" :disabled="props.item.SprayID < 0" block @click="showDeleteSprayDialog(props.item)">Delete</v-btn></td>
                    </template>
                </v-data-table> 
            </v-flex>
        </v-layout> 
        <!-- Add edit dialog -->
        <v-dialog v-model="showAddSprayDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="saving" @click="cancelEditSpray">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="editedSpray.Editing">Edit Spray Entry</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Spray Entry</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                    </v-toolbar-items>
                </v-toolbar>
                <v-form ref="editForm" v-model="editSprayValid">
                    <v-layout class="dialog-content">      
                        <v-flex xs12 md6 offset-md3 mt-4 px-1  >
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-select label="Plant" v-model="selectedPlantDialog" :items="plantsDialog" item-text="PlantName" item-value="PlantID" :rules="[rules.selectRequired]"></v-select>
                                </v-flex>
                                <v-flex xs12>
                                     <v-select label="Division"  v-model="selectedDivisionDialog" :items="divisionsDialog" item-text="DivisionName" item-value="DivisionID" :rules="[rules.selectRequired]"></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-select label="Location" v-model="selectedLocationDialog" :items="locationsDialog" item-text="LocationName" item-value="LocationID" :rules="[rules.selectRequired]"></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-select label="Product / Chemical" v-model="editedSpray.SprayConfigurationID" :items="sprayConfigurations" item-text="ProductChemical" item-value="SprayConfigurationID" :rules="[rules.selectRequired]"></v-select>
                                </v-flex>
                                <v-flex xs12> 
                                        <v-menu
                                            ref="menu"
                                            v-model="dateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px">
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="date"
                                                label="Spray Date"
                                                prepend-icon="event"
                                                readonly v-on="on" :rules="[rules.required]"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date" @input="dateMenu = false" ></v-date-picker>
                                        </v-menu>
                                </v-flex>
                                <v-flex xs12>
                                      <v-menu
                                        ref="menu"
                                        v-model="timeMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="time"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px">
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="time"
                                                label="Spray Time"
                                                prepend-icon="access_time"
                                                readonly
                                                :rules="[rules.required]"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-time-picker
                                            v-if="timeMenu"
                                            v-model="time"
                                            full-width
                                            @click:minute="$refs.menu.save(time)"
                                            ></v-time-picker>
                                        </v-menu>
                                </v-flex>
                                <v-flex xs12>
                                       <v-checkbox label="Allow Pick" v-model="editedSpray.AllowPick"></v-checkbox>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="dialog-action-buttons">
                                <v-flex xs12 sm6>
                                    <v-btn block color="success" :disabled="!editSprayValid" :loading="saving" @click="saveSpray">Save</v-btn>
                                </v-flex>
                                 <v-flex xs12 sm6 >
                                    <v-btn block color="error" :disabled="saving" @click="cancelEditSpray">Cancel</v-btn>
                                </v-flex>
                                <v-flex xs12>
                                        <v-alert :value="saveError"
                                            outline
                                            type="error">
                                            {{saveError}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>                            
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- Confirm Delete Dialog -->
        <v-dialog v-model="showDeleteDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Delete Spray</v-card-title>
                <v-card-text>Are you sure you want to delete this spray?</v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" block :disabled="loading"  @click="confirmDeleteSpray()">Yes</v-btn>
                <v-btn color="error" block :disabled="loading"  @click="cancelDeleteSpray()">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
             <v-bottom-sheet full-width v-model="importSheet" persistent >
                <div class="sprayImportBottomSheet">
                    <v-progress-linear v-if="isImporting" indeterminate></v-progress-linear>
                    <spray-importer
                        @Close="sprayImportClosed"
                        @Save="sprayImportSaved"
                        :MaxFileSizeMB="100"
                        :MultipleFilesImport="false"
                        :IsImporting="isImporting"
                        AllowedFileExtensions=".csv"/>
                    <spray-import-result :ImportResult="importResult"/> 
                </div>
            </v-bottom-sheet>
    </v-layout>
</template>

<script>
import UnsyncedStatusIndicator from '@/components/generic/UnsyncedStatusIndicator.vue';
import validationRules from "../../helpers/validationrules";
import moment from 'moment'
import SprayImporter from "@/components/spray/SprayImporter.vue";
import SprayImportResult from "@/components/spray/SprayImportResult.vue"
export default {
    data() {
        return {
            rules: validationRules.rules,
            loading: false,
            saving: false,
            editSprayValid: false,
            showAddSprayDialog: false,
            showDeleteDialog: false,
            deleteSpray: null,
            editedSpray: {},
            saveError: null,
            selectedPlant: null,
            selectedDivision: null,
            selectedLocation: null,
            selectedPlantDialog: null,
            selectedDivisionDialog: null,
            selectedLocationDialog: null,
            date: null,
            time: null,
            dateMenu: null,
            timeMenu: null,
            searchPlant: null,
            importSheet: false,
            isImporting: false,
            importResult: null,
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: false
            },
            rowsPerPageItems: [10, 25, 50, 100],
            headers: [
                {
                    text: "Plant",
                    value: "PlantName",
                    align: 'left'
                },
                {
                    text: "Division",
                    value: "DivisionName",
                    align: 'left'
                },
                {
                    text: "Location",
                    value: "LocationName",
                    align: 'left'
                },
                {
                    text: "Product / Chemical",
                    value: "ProductChemical",
                    align: 'left',
                },
                {
                    text: "Spray Date Time",
                    value: "SprayDateTime",
                    align: 'left'
                },
                {
                    text: "Withhold Until Date Time",
                    value: "WithholdDateTime",
                    align: 'left',
                },
                {
                    text: "Valid Until Date Time",
                    value: "ValidDateTime",
                    align: 'left',
                },
                {
                    text: "Allow Pick",
                    value: "AllowPick",
                    align: 'left',
                },
                {
                    text: "Edit",
                    value: "",
                    align: "left",
                    sortable: false
                },
                {
                    text: "Delete",
                    value: "",
                    align: "left",
                    sortable: false
                }
            ]
        }
    },
    props: [
        'masterData'
    ],
    components: {
        UnsyncedStatusIndicator,
        SprayImporter,
        SprayImportResult
    },
    watch: {
        selectedPlant() {
            this.selectedDivision = null;
        },
        selectedPlantDialog(newVal, oldVal) {
            if(oldVal != null) {
               this.selectedDivisionDialog = null;
            }
        }
    },
    computed: {
         totalUnSyncedSpraies(){
            return this.$store.getters["SprayStore/getTotalUnSyncedSpraies"];
        },
         unsyncedSprayAddEntries() {       
            return this.totalUnSyncedSpraies.unAddSpraies;
        },
         unsyncedSprayEditEntries() {
          return this.totalUnSyncedSpraies.unUpdateSpraies;
        },
        unsyncedSprayDeleteEntries() {
            return this.totalUnSyncedSpraies.unDeleteSpraies;
        },
        spraies() {
            if(this.masterData) {
                return this.$store.getters["SprayStore/getSpraies"](this.selectedPlant, this.selectedDivision, this.selectedLocation);
            } else {
                return [];
            }
        },
        plants() {
            return this.masterData ? this.masterData.Plants : [];
        },
        divisions() {
            let self = this;

            return this.$store.getters["SprayStore/getDivisionsForPlants"].filter(d => {
                let match = true;

                if (self.selectedPlant && self.selectedPlant.length > 0 && self.selectedPlant.indexOf(d.PlantID) < 0) {
                    match = false;                    
                }

                return match;
            }).sort((a, b) => {
                if(a.DivisionName.toLowerCase() < b.DivisionName.toLowerCase()) {
                    return -1;
                }

                if(a.DivisionName.toLowerCase() > b.DivisionName.toLowerCase()) {
                    return 1;
                }

                return 0;
            });
        },
        locations() {
            let self = this;

            return this.$store.getters["SprayStore/getLocationsForPlants"].filter(l => {
                let match = true;

                if (self.selectedDivision && self.selectedDivision.length > 0 && self.selectedDivision.indexOf(l.DivisionID) < 0) {
                    match = false;
                }

                return match
            }).sort((a, b) => {
                if(a.LocationName.toLowerCase() < b.LocationName.toLowerCase()) {
                    return -1;
                }

                if(a.LocationName.toLowerCase() > b.LocationName.toLowerCase()) {
                    return 1;
                }

                return 0;
            });
        },
        sprayConfigurations() {
            if(this.masterData && this.masterData.SprayConfigurations) {
                var sprayConfigurations = this.masterData.SprayConfigurations;
                return sprayConfigurations.sort((a,b) => {
                    if ( a.ProductChemical.toLowerCase() < b.ProductChemical.toLowerCase()){
                        return -1;
                    }
                    if ( a.ProductChemical.toLowerCase() > b.ProductChemical.toLowerCase()){
                        return 1;
                    }
                    return 0;
                })
            } else {
                return [];
            }
        },
        plantsDialog() {
            return this.masterData ? this.masterData.Plants : [];
        },
        divisionsDialog() {
            if(this.masterData && this.selectedPlantDialog) {
                return this.$store.getters["SprayStore/getDivisions"](this.selectedPlantDialog);
            } else {
                return [];
            }
        },
        locationsDialog() {
           if(this.masterData && this.selectedDivisionDialog) {
                return this.$store.getters["SprayStore/getLocations"](this.selectedDivisionDialog);
            } else {
                return [];
            }
        },
        sprayDateTimeEdit() {
            if(this.date && this.time) {
                var sprayDateTime = moment(this.date + ' ' + this.time);
                return sprayDateTime;
            } else {
                return "";
            }
        },
        withholdUntilEdit() {
            if(this.date && this.time && this.editedSpray && this.editedSpray.SprayConfigurationID) {
                var sprayConfiguration = this.sprayConfigurations.find(sc=> sc.SprayConfigurationID == this.editedSpray.SprayConfigurationID);
                if(sprayConfiguration) {
                    var sprayDateTime = moment(this.date + ' ' + this.time);
                    return sprayDateTime.add(sprayConfiguration.WithholdPeriod, 'hours').format("DD/MM/YYYY hh:mm A");
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        validUntilEdit() {
            if(this.date && this.time && this.editedSpray && this.editedSpray.SprayConfigurationID) {
                var sprayConfiguration = this.sprayConfigurations.find(sc=> sc.SprayConfigurationID == this.editedSpray.SprayConfigurationID);
                if(sprayConfiguration) {
                    var sprayDateTime = moment(this.date + ' ' + this.time);
                    return sprayDateTime.add(sprayConfiguration.ValidPeriod, 'hours').format("DD/MM/YYYY hh:mm A");
                } else {
                    return "";
                }
            } else {
                return "";
            }
        }
    },
    methods: {
        async syncUnsyncedData() {
            this.loading = true;

            try {
                await this.$store.dispatch("SprayStore/syncUnsyncedData");
            } catch(err){
                this.showSyncError();                
            }

            this.loading = false;
        },
        showSyncError(){
            alert("Unable to sync.");
        },
        cancelEditSpray() {
            this.showAddSprayDialog = false;
            this.editedSpray = {};
            this.date = null;
            this.time = null;
            this.selectedPlantDialog = null;
            this.selectedDivisionDialog = null;
            this.selectedLocationDialog = null;
        },
        async saveSpray() {
            this.saving = true;
            this.editedSpray.SprayDateTime = this.sprayDateTimeEdit.format();
            if(!this.editedSpray.AddDateTime) {
                this.editedSpray.AddDateTime = moment().format();
            }
            this.editedSpray.AddDateTimeTemp = moment().format();
            this.editedSpray.PlantID = this.selectedPlantDialog;
            this.editedSpray.DivisionID = this.selectedDivisionDialog;
            this.editedSpray.LocationID = this.selectedLocationDialog;
            if(this.editedSpray.Editing) {
                await this.$store.dispatch("SprayStore/updateSpray", this.editedSpray);
            } else {
                this.editedSpray.SprayID = -1;
                await this.$store.dispatch("SprayStore/addSpray", this.editedSpray);
            }
            this.cancelEditSpray();
            this.saving = false;
        },
        showDeleteSprayDialog(spray) {
            this.showDeleteDialog = true;
            this.deleteSpray = spray;
        },
        async confirmDeleteSpray() {
            this.loading = true;
            await this.$store.dispatch("SprayStore/deleteSpray", this.deleteSpray);
            this.loading = false;
            this.showDeleteDialog = false;
        },
        cancelDeleteSpray() {
            this.deleteSprayID = null;
            this.showDeleteDialog = false;
        },
        addSpray() {
            this.showEditAddSpray();
        },
        editSpray(spray) {
            this.showEditAddSpray(Object.assign({}, spray));
        },
        showEditAddSpray(spray) {
            if(spray) {
                this.editedSpray = spray;
                this.editedSpray.Editing = true;
                this.date = moment(this.editedSpray.SprayDateTime).format("YYYY-MM-DD");
                this.time = moment(this.editedSpray.SprayDateTime).format("HH:mm");
                this.selectedPlantDialog = spray.PlantID;
                this.selectedDivisionDialog = spray.DivisionID;
                this.selectedLocationDialog = spray.LocationID;
            } else {
                this.$refs.editForm.reset();
                this.editedSpray = {Editing: false, Status: true};
            }
            this.showAddSprayDialog = true;
            
            this.saveError = null;
        },
        clearFilter() {
            this.selectedPlant = null;
            this.selectedDivision = null;
            this.selectedLocation = null;
            this.filter = {};
        },
        showImportSpray() {
            this.importSheet = true;
            this.importResult = null;
        },
        async sprayImportSaved(file) {
            this.isImporting = true;
            this.importResult = await this.$store.dispatch("SprayStore/importSpray", {FileName: file.name, FileBlob: file.data});
            this.isImporting = false;

        },
        async sprayImportClosed() {
            this.importSheet = false;
            this.importResult = null;
            await this.syncUnsyncedData();
        }
    },
    async created() {
      
    }
}
</script>

<style>
.sprayImportBottomSheet {
    background-color: white;
    padding: 15px;
    min-height: 300px;
}
.sparyManagementTable .v-table__overflow  {
    overflow-y: auto;
    height: calc(100vh - 470px);
}
</style>
